(function() {
jQuery(function() {
  $(document).on("click", "#i_am_race_team", (function(_this) {
    return function(event) {
      var $main_btn, $other_btn;
      event.preventDefault();
      $main_btn = $(event.target);
      $main_btn.removeClass("btn-default");
      $main_btn.addClass("btn-primary");
      $other_btn = $("#i_am_engine_builder");
      $other_btn.removeClass("btn-primary");
      $other_btn.addClass("btn-default");
      $("#company_type").val("RaceTeam");
      return $.post("/register/companies/type", {
        type: "RaceTeam"
      });
    };
  })(this));
  return $(document).on("click", "#i_am_engine_builder", (function(_this) {
    return function(event) {
      var $main_btn, $other_btn;
      event.preventDefault();
      $main_btn = $(event.target);
      $main_btn.removeClass("btn-default");
      $main_btn.addClass("btn-primary");
      $other_btn = $("#i_am_race_team");
      $other_btn.removeClass("btn-primary");
      $other_btn.addClass("btn-default");
      $("#company_type").val("EngineBuilder");
      return $.post("/register/companies/type", {
        type: "EngineBuilder"
      });
    };
  })(this));
});

}).call(window);
